var _defs, _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack1118({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "8 1.94 1 14.06 15 14.06 8 1.94"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "2.73 13.06 8 3.94 13.27 13.06 2.73 13.06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack1118);
export default __webpack_public_path__ + "static/media/Symbolpack_1_118.aa5951a6360c155e9d589ab8baddc39a.svg";
export { ForwardRef as ReactComponent };